import { UserManager, WebStorageStateStore } from 'oidc-client';
import { CONFIG } from '@/config';
import {http} from '@/services/http.service';

export default class AuthService {
  qs = require('qs');
  userManager;

  constructor() {
    const {protocol, hostname} = location;
    let port = ':4200';

    if(CONFIG.NODE_ENV === 'development' && hostname === 'localhost')
      port = ':4200';

    const settings = {
      client_id: CONFIG.CLIENT_ID,
      client_secret: 'neocom123',
      grant_type: 'client_credentials',
      scope: 'Neocom.Neogig.Api',
    };

    this.userManager = new UserManager(settings);
  }

  getAccessToken() {
    this.userManager.createSigninRequest({ data: { bar: 15 } })
      .then((res: any) => {
        window.location = res.url;
      })
      .catch(e => {
        console.log(e);
      });
  }

  getUser() {
    return this.userManager.getUser()
  }

  login() {
    return this.userManager.signinRedirect();
  }

  logout() {
    return this.userManager.signoutRedirect();
  }

  getAccessTokenHeader() {
    return {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    };
  }

  revokeAccessToken() {
    return this.userManager.revokeAccessToken();
  }

  async isAuthenticated() {
    const settings = {
      client_id: CONFIG.CLIENT_ID,
      client_secret: 'neocom123',
      grant_type: 'client_credentials',
      scope: 'Neocom.Neogig.Api',
    };

    await
    http.post(
      `${CONFIG.URL.IDENTITY_SERVER}/connect/token`,
      this.qs.stringify(settings),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then((user) => {
        if(user.data !== null) {
          sessionStorage.setItem('token', user.data.access_token);
          sessionStorage.setItem('tokenType', user.data.token_type);

          return true;
        }
        return false;
      });
  }
}
